import { Box, BoxProps } from '@chakra-ui/react';

export const BaseChartImage = ({ children, ...props }: BoxProps) => (
    <Box
        position="absolute"
        top="50%"
        left={0}
        right="-1px"
        transform="translate3d(0, -50%, 0)"
        overflow="hidden"
        display="flex"
        justifyContent="flex-end"
        zIndex={-2}
        {...props}
    >
        <Box>{children}</Box>
    </Box>
);
